import { cloneDeep } from 'lodash';
import * as React from 'react';

import { IDocument, ILogo, IUserData } from '../../../../infrastructure/interfaces';
import LogoEditorForm from '../../../DocumentEditor/LogoEditorForm';
import SettingsNav from './SettingsNav';

export interface ILogoEditorProps {
  document: IDocument;
  userData: IUserData,
  logos: ILogo[];
  updateDocument(document: IDocument, userID: string): void;
  updateModelDocument?(document: IDocument): void;
  cancelDocument?(): void;
}

export interface ILogoEditorState {
  document: IDocument;
}

export default class LogoEditor extends React.Component<ILogoEditorProps, ILogoEditorState> {
  constructor(props: ILogoEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: ILogoEditorProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  toggleLogo = (logo: ILogo) => {
    const document = this.state.document;
    let logos = [...document.logos];

    if (logos.findIndex(l => l.id === logo.id) > -1) {
      logos = logos.filter(l => l.id !== logo.id);
    } else {
      logos.push(logo);
    }

    this.setState({
      document: {
        ...document,
        logos,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.updateDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer">
        <SettingsNav
          onSave={this.onSave}
          cancel={this.cancel}
          document={this.state.document}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Back Cover Co-branding
          </div>
        </div>
        <LogoEditorForm
          className="settingsCropsListContainer"
          document={this.state.document}
          logos={this.props.logos}
          toggleLogo={this.toggleLogo}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/LogoEditor.tsx